<div class="flex flex-col">
  <div class="relative">
    <input
      #searchInput
      matInput
      [placeholder]="'common.search' | translate"
      [formControl]="control"
      class="h-8 min-w-[312px] !pl-8 text-sm xl:text-base"
    />

    <mat-icon class="absolute left-1 top-1/2 -translate-y-1/2 text-black/50"> search </mat-icon>
  </div>

  <div class="h-0 w-full -translate-x-1/2" [matMenuTriggerFor]="resultTemplate"></div>
</div>

<mat-menu #resultTemplate="matMenu" class="!min-w-0 !max-w-[unset]">
  <!-- eslint-disable-next-line -->
  <div (click)="$event.stopPropagation()">
    <div class="flex w-[600px] flex-col py-4">
      @if (loading) {
        <mat-spinner diameter="20" class="mx-auto" />
      }
      @if (!loading && !showingResult.length) {
        <p class="!mb-0 text-center">{{ 'search.no-result-found' | translate }}</p>
      }
      @if (!loading && showingResult.length) {
        <div class="mx-4 mb-4 flex space-x-2">
          @for (type of types; track type.type) {
            @if (selectedType === type.type) {
              <button mat-flat-button class="type-btn" (click)="onSelectFilterType(type.type)">
                ({{ type.count }}) {{ SearchResultTypeLabel[type.type] | translate }}
              </button>
            } @else {
              <button mat-button class="type-btn" (click)="onSelectFilterType(type.type)">
                ({{ type.count }}) {{ SearchResultTypeLabel[type.type] | translate }}
              </button>
            }
          }
        </div>

        @if (showingResult.length) {
          <div class="flex max-h-[60vh] flex-col gap-1 overflow-auto">
            @for (item of showingResult; track item.title) {
              <a mat-button [href]="item.link" class="item-btn w-full !justify-start">
                <div class="flex w-full items-center gap-4">
                  @if (item.thumbnail) {
                    <img [src]="item.thumbnail" [alt]="item.title" class="h-10 w-10" />
                  }

                  <div class="flex flex-col space-y-1">
                    <span>{{ item.title }}</span>
                    <span class="text-xs text-text-2">{{ item.subtitle }}</span>
                  </div>
                </div>
              </a>
            }
          </div>
        }
        @if (showingLeft !== 0) {
          <button mat-button (click)="onShowFull()">
            {{
              isShowFull
                ? ('search.show-less' | translate)
                : ('search.show-full' | translate) + ' (' + showingLeft + ')'
            }}
          </button>
        }
      }
    </div>
  </div>
</mat-menu>
